export const DashboardConstants = {
  dashboard: 'यह डैशबोर्ड है',
};
